// @flow

export const locations = (state: $ElementType<ReduxState, 'locations'> = []) => state;
